var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.8335V3.16683M4 1.8335V3.16683",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9957 9.1665H8.0017M7.9957 11.8332H8.0017M10.6594 9.1665H10.6654M5.33203 9.1665H5.33801M5.33203 11.8332H5.33801",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 5.8335H13.6654",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 8.66213C1.66797 5.75729 1.66797 4.30485 2.50272 3.40243C3.33746 2.5 4.68096 2.5 7.36797 2.5H8.63463C11.3216 2.5 12.6652 2.5 13.4999 3.40243C14.3346 4.30485 14.3346 5.75729 14.3346 8.66213V9.00453C14.3346 11.9094 14.3346 13.3618 13.4999 14.2643C12.6652 15.1667 11.3216 15.1667 8.63463 15.1667H7.36797C4.68096 15.1667 3.33746 15.1667 2.50272 14.2643C1.66797 13.3618 1.66797 11.9094 1.66797 9.00453V8.66213Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.8335H14",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fb6e5d1d3967f3a7045a410fe2ac90ca.svg";
export { ForwardRef as ReactComponent };